import React, { useState } from 'react';
import HomeIcon from './HomeIcon';
import s from './HomeCollection.module.css';

// The first-visit line above a Collection-only Home. "Got it" removes it for good — a per-person, per-browser
// convenience (localStorage, wrapped: a private window just shows it again). It is not a setting and not shared.
const keyOf = (userId) => `clb.home.collection-welcome.v1:${userId || 'anon'}`;
const seen = (key) => { try { return window.localStorage.getItem(key) === '1'; } catch (_) { return false; } };

export default function HomeCollectionNote({ userId, name, season }) {
  const key = keyOf(userId);
  const [gone, setGone] = useState(() => seen(key));
  if (gone) return null;
  const dismiss = () => { try { window.localStorage.setItem(key, '1'); } catch (_) { /* fine */ } setGone(true); };
  return (
    <div className={s.note} role="status" data-test="home-collection-note">
      <span className={s.noteIcon}><HomeIcon name="spark" /></span>
      <p><b>Welcome, {name}.</b> The {season ? `${season} ` : ''}Collection is on your Home now — open the Wall to see every model.</p>
      <button type="button" onClick={dismiss}>Got it</button>
    </div>
  );
}
